import React from "react";
import { styled } from '@mui/material/styles';
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Select from "@mui/material/Select";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";

const PREFIX = 'NewSemesterDialog';

const classes = {
  root: `${PREFIX}-root`,
  demo: `${PREFIX}-demo`,
  title: `${PREFIX}-title`,
  formControl: `${PREFIX}-formControl`,
  textField: `${PREFIX}-textField`,
  button: `${PREFIX}-button`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    flexGrow: 1,
    maxWidth: 752
  },

  [`& .${classes.demo}`]: {
    background: theme.palette.background.paper
  },

  [`& .${classes.title}`]: {
    margin: `${theme.spacing(4)} 0 ${theme.spacing(2)}`
  },

  [`& .${classes.formControl}`]: {
    margin: theme.spacing(1),
    minWidth: 120
  },

  [`& .${classes.textField}`]: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200
  },

  [`& .${classes.button}`]: {
    margin: theme.spacing(1)
  }
}));

class NewSemesterDialog extends React.Component {
  state = {
    startYear: "",
    add: false,
    newClass: ""
  };

  getDates = () => {
    var currentYear = new Date().getFullYear();
    var yearsAhead = [1, 2, 3, 4, 5];
    var menuItems = [];
    yearsAhead.map(add1 => {
      var futureDate = new Date(currentYear + add1, 8);
      while (futureDate.getDay() !== 1) {
        futureDate.setDate(futureDate.getDate() + 1);
      }
      return menuItems.push(
        <MenuItem
          key={add1}
          value={`${futureDate.getFullYear()}-${futureDate.getFullYear() + 1}`}
        >
          {futureDate.toDateString()}
        </MenuItem>
      );
    });
    return menuItems;
  };

  handleSelectChange = year => event => {
    this.setState({ startYear: event.target.value, touched: true });
  };

  addSemesterHandler = () => {
    this.props.handleCreateSemester(this.state.startYear);
  };

  render() {
    const {  handleToggleDialog, open, classTemplates } = this.props;
    return (
      <Root>
        <Dialog open={open} onClose={handleToggleDialog}>
          <DialogTitle>{"Tilføj nyt semester?"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Når du tilføjer et nyt semester bliver alle hold og linier
              automatisk oprettet som flg.:
            </DialogContentText>
            <Grid container>
              <Grid item xs={12}>
                <FormControl
                  className={classes.formControl}
                  error={this.state.startYear === ""}
                >
                  <InputLabel htmlFor="age-helper">Start dato</InputLabel>
                  <Select
                    value={this.state.startYear}
                    onChange={this.handleSelectChange("startYear")}
                    input={<Input id="start-year-helper" />}
                  >
                    <MenuItem value="">
                      <em>Vælg</em>
                    </MenuItem>
                    {this.getDates()}
                  </Select>
                  <FormHelperText>
                    Vælg startår for det semester du vil oprette
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className={classes.demo}>
                  <List>
                    {Object.keys(classTemplates).map(key => {
                      return (
                        <ListItem button key={key}>
                          <ListItemIcon>
                            <ClearIcon />
                          </ListItemIcon>
                          <ListItemText primary={classTemplates[key]} />
                        </ListItem>
                      );
                    })}
                    {this.state.add && (
                      <div>
                        <Input
                          name="add"
                          type="text"
                          value={this.state.newClass}
                          placeholder="Holdnavn"
                          className={classes.textField}
                          onChange={e =>
                            this.setState({ newClass: e.target.value })
                          }
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  this.props.handleCreateClass(
                                    this.state.newClass
                                  )
                                }
                                size="large">
                                <DoneIcon />
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </div>
                    )}
                    <ListItem
                      button
                      onClick={() => {
                        this.setState({ add: !this.state.add });
                      }}
                    >
                      <ListItemIcon>
                        <AddIcon />
                      </ListItemIcon>
                      <ListItemText primary={"Tilføj hold"} />
                    </ListItem>
                  </List>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleToggleDialog()}>
              Annuller
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={this.state.startYear === ""}
              onClick={() => {
                this.addSemesterHandler();
              }}
            >
              Tilføj
            </Button>
          </DialogActions>
        </Dialog>
      </Root>
    );
  }
}
NewSemesterDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleToggleDialog: PropTypes.func.isRequired
};
export default (NewSemesterDialog);
